import React from "react";
import Header from "../../layout/Header";
import { Link } from "react-router-dom";
import Leftpanel from "../../layout/Leftpanel";

const Unspsc = () => {
  return (
    <div className="container-fluid">
      <div className="dbMain unspsc">
        <Leftpanel />
        <div className="dbRight">
          <Header link="/dashboard" title="UNSPSC" description="" />
          <div className="commonBase mb-4">
            <div className="unspTop">
              <select className="form-control">
                <option>Select segment code</option>
              </select>
              <div className="unsel">
                <select className="form-control">
                  <option>Select UNSPSC</option>
                </select>
                &nbsp;&nbsp;
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter GL key"
                />
              </div>
            </div>

            <div className="accordion unspscAccord" id="unAccordion">
              <div className="accordion-item">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseA"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Segment Code : 10000000, Title : Live Plant and Animal
                  Material and Accessories and Supplies
                </button>
                <div
                  id="collapseA"
                  className="accordion-collapse collapse show"
                  aria-labelledby="hdOne"
                  data-bs-parent="#unAccordion"
                >
                  <div className="accordion-body parentAccord">
                    <div className="accordion" id="sub-unAccordion">
                      <div className="accordion-item">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#sub-collapseOne"
                          aria-expanded="false"
                          aria-controls="collapseOne"
                        >
                          Family Code : 10100000, Title : Live animals
                        </button>
                        <div
                          id="sub-collapseOne"
                          className="accordion-collapse collapse"
                          aria-labelledby="sub-hdOne"
                          data-bs-parent="#sub-unAccordion"
                        >
                          <div className="accordion-body">
                            <p>fdsfdsf</p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#sub-collapseTwo"
                          aria-expanded="true"
                          aria-controls="sub-collapseTwo"
                        >
                          Family Code : 10100000, Title : Live animals | GL Key
                          : 215514
                        </button>
                        <div
                          id="sub-collapseTwo"
                          className="accordion-collapse collapse show"
                          aria-labelledby="sub-headingTwo"
                          data-bs-parent="#sub-unAccordion"
                        >
                          <div className="accordion-body">
                            <div className="accordion" id="sub-sub-unAccordion">
                              <div className="accordion-item">
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#sub-sub-collapseOne"
                                  aria-expanded="false"
                                  aria-controls="collapseOnesub"
                                >
                                  Class Code : 10101600, Title : Birds and fowl
                                  | GL Key : 215514
                                </button>
                                <div
                                  id="sub-sub-collapseOne"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="sub-sub-hdOne"
                                  data-bs-parent="#sub-sub-unAccordion"
                                >
                                  <div className="accordion-body">
                                    <div
                                      className="accordion"
                                      id="sub-sub-sub-unAccordion"
                                    >
                                      <div className="accordion-item">
                                        <button
                                          className="accordion-button collapsed"
                                          type="button"
                                          data-bs-toggle="collapse"
                                          data-bs-target="#sub-sub-sub-collapseOne"
                                          aria-expanded="false"
                                          aria-controls="collapseOnesub"
                                        >
                                          Commodity Code : 10101501, Title :
                                          Cats | GL Key : 215514
                                        </button>
                                        <div
                                          id="sub-sub-sub-collapseOne"
                                          className="accordion-collapse collapse"
                                          aria-labelledby="sub-sub-sub-hdOne"
                                          data-bs-parent="#sub-sub-sub-unAccordion"
                                        >
                                          <div className="accordion-body">1x</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="accordion-item">
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#sub-sub-collapseTwo"
                                  aria-expanded="false"
                                  aria-controls="collapseTwosub"
                                >
                                  Class Code : 10101700, Title : Live fish | GL
                                  Key : 215514
                                </button>
                                <div
                                  id="sub-sub-collapseTwo"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="sub-sub-hdTwo"
                                  data-bs-parent="#sub-sub-unAccordion"
                                >
                                  <div className="accordion-body">2</div>
                                </div>
                              </div>
                              <div className="accordion-item">
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#sub-sub-collapseThree"
                                  aria-expanded="false"
                                  aria-controls="collapseThreesub"
                                >
                                  child child3
                                </button>
                                <div
                                  id="sub-sub-collapseThree"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="sub-sub-hdThree"
                                  data-bs-parent="#sub-sub-unAccordion"
                                >
                                  <div className="accordion-body">3</div>
                                </div>
                              </div>
                              <div className="accordion-item">
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#sub-sub-collapseFour"
                                  aria-expanded="false"
                                  aria-controls="collapseFoursub"
                                >
                                  child child 4
                                </button>
                                <div
                                  id="sub-sub-collapseFour"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="sub-sub-hdFour"
                                  data-bs-parent="#sub-sub-unAccordion"
                                >
                                  <div className="accordion-body">4</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#sub-collapseThree"
                          aria-expanded="false"
                          aria-controls="sub-collapseThree"
                        >
                          Family Code : 10120000, Title : Animal feed
                        </button>
                        <div
                          id="sub-collapseThree"
                          className="accordion-collapse collapse"
                          aria-labelledby="sub-headingThree"
                          data-bs-parent="#sub-unAccordion"
                        >
                          <div className="accordion-body">
                            <strong>
                              This is the second item's accordion body.
                            </strong>{" "}
                            It is hidden by default, until the collapse plugin
                            adds the appropriate classes that we use to style
                            each element. These classes control the overall
                            appearance, as well as the showing and hiding via
                            CSS transitions. You can modify any of this with
                            custom CSS or overriding our default variables. It's
                            also worth noting that just about any HTML can go
                            within the <code>.accordion-body</code>, though the
                            transition does limit overflow.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#sub-collapseFour"
                          aria-expanded="false"
                          aria-controls="sub-collapseFour"
                        >
                          Familty Code : 10130000, Title : Animal containment
                          and habitats
                        </button>
                        <div
                          id="sub-collapseFour"
                          className="accordion-collapse collapse"
                          aria-labelledby="sub-headingFour"
                          data-bs-parent="#sub-unAccordion"
                        >
                          <div className="accordion-body">
                            <strong>
                              This is the second item's accordion body.
                            </strong>{" "}
                            It is hidden by default, until the collapse plugin
                            adds the appropriate classes that we use to style
                            each element. These classes control the overall
                            appearance, as well as the showing and hiding via
                            CSS transitions. You can modify any of this with
                            custom CSS or overriding our default variables. It's
                            also worth noting that just about any HTML can go
                            within the <code>.accordion-body</code>, though the
                            transition does limit overflow.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="accordion-item">
                                <h2 className="accordion-header" id="headingTwo">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseB" aria-expanded="false" aria-controls="collapseTwo">
                                        Parent 2
                                    </button>
                                </h2>
                                <div id="collapseB" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#unAccordion">
                                    <div className="accordion-body">
                                        <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingThree">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                        Parent 3
                                    </button>
                                </h2>
                                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#unAccordion">
                                    <div className="accordion-body">
                                        <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                                    </div>
                                </div>
                            </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unspsc;
